module.exports = __webpack_public_path__ + "static/img/icon_y_erp.a788f748.png";